import titleImage from '@assets/images/01.png';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Loading } from '@/components/Loading';
import { AuthenticatedButtons } from '@/pages/home/components/AuthenticatedButtons';
import { UnauthenticatedButtons } from '@/pages/home/components/UnauthenticatedButtons';
import { useHomePage } from '@/pages/home/useHomePage';

export const HomePage = () => {
  const {
    isLoading,
    isAuthenticated,
    profileUserName,
    handleLogin,
    handleStartGame,
    handleLogout,
  } = useHomePage();

  if (isLoading) return <Loading />;

  return (
    <div className="h-svh max-w-full overflow-clip bg-linear-to-br from-purple-600 via-pink-600 to-blue-600 grid place-items-center">
      <div className="text-center grid gap-50 grid-auto-rows-max">
        <header className="grid gap-16">
          <div className="flex items-center justify-center w-full relative">
            <img
              src={titleImage}
              alt=""
              className="h-96 w-auto animate-spin absolute left-[-40%]"
            />
            <h1 className="text-2xl md:text-3xl font-bold text-white flex flex-col md:flex-row md:gap-2">
              <span>無性生殖！？</span>
              <span>問山くん</span>
            </h1>
            <img
              src={titleImage}
              alt=""
              className="h-96 w-auto animate-[spin_1s_linear_infinite_reverse] absolute right-[-40%]"
            />
          </div>

          {profileUserName && (
            <p className="text-white text-lg max-w-200 md:max-w-500 break-all">
              ようこそ、{profileUserName}さん
            </p>
          )}
        </header>

        <div className="grid gap-24">
          {isAuthenticated ? (
            <AuthenticatedButtons
              onStartGame={handleStartGame}
              onLogout={handleLogout}
            />
          ) : (
            <UnauthenticatedButtons onLogin={handleLogin} />
          )}
          <Button asChild className="py-[0.8em]">
            <Link to="/results">ランキング</Link>
          </Button>
        </div>
      </div>
    </div>
  );
};
